<template>
<div>
    <div class="connerwidth boxSizing category">
        <p class="title">
            <span class="iconfont" :class="data.iconClass"></span>
            <em v-text="data.title"></em>
        </p>
        <!-- <categoryList v-for="(item, i) of listData" :data="item" :url="data.detailsUrl" :key="i" @click.native="details(item.id)"></categoryList> -->
        <div>
            <router-link v-for="(item, i) of listData" v-bind:to="data.detailsName + item.id">
                <categoryList    :data="item" :url="data.detailsUrl" :key="i" ></categoryList>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
import categoryList from "./categoryList";
import moment from "moment/moment.js";

function ajaxDataForData(ajaxData, vue) {
    console.log('ajaxData',ajaxData);
    let _this = vue;

        ajaxData.author = ajaxData.author || "";
        ajaxData.title = ajaxData.name || ajaxData.title;
        ajaxData.teachArr = ajaxData.author.split(",") || [];
        ajaxData.money = ajaxData.price || "免费";
        ajaxData.redu = ajaxData.browseNum || ajaxData.chapters || ajaxData.attentionCount ||0;
        ajaxData.keshi = ajaxData.classHour || ajaxData.see_count || 0;
        ajaxData.imgPath = ajaxData.cover || "http://m.wm319.com/img/cover.png";

  // if (_this.data.title !== '精讲课程') {
  //   ajaxData.teachArr = [];
  //   if (_this.data.title === '电子书') ajaxData.redu = 'none';
  // }
  switch (_this.data.title) {
    case "天天听书":
      ajaxData.teachArr = [];
      break;
    case "电子书":
      ajaxData.teachArr = [];
      ajaxData.redu = "none";
      break;
    default:
  }
  return ajaxData;
}
var details = function (id) {
  alert('asdas')
    // this.$router.push({ name: this.data.detailsName, params: { id: id } });
};
export default {
  name: "category",
  created() {
    console.log(this.data);
    let ajaxData = this.data.ajaxData;

    if(ajaxData){

      for (let i = 0; i < ajaxData.length; i++) {
        ajaxData[i] = ajaxDataForData(ajaxData[i], this);
      }
      this.listData = ajaxData;
    }

  },
  data() {
    return {
      listData: "",
    };
  },
  methods: {
    details,
    ConvertToTime(timespan){
      return moment(timespan).format("HH:mm");
    },
    ConvertToDate(timespan){
      return moment(timespan).format("YYYY.MM.DD");
    }
  },
  props: ["data"],
  components: {
    categoryList
  },
  directives: {
    clicks: {
      // 指令的定义
      inserted: function (el) {
        el.onclick = function () {
          alert('点击成功');
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.category {
  margin-bottom: 20px;
  background: #fff;
  /deep/ .categoryList:last-child {
    .line div {
      border-bottom: none;
    }
  }
}
.connerwidth {
  width: 100%;
  padding: 0 30px;
  font-size: 0;
}
.title {
  font-size: 0;
  display: inline-block;
  .iconfont {
    font-size: 40px;
    line-height: 90px;
    background: linear-gradient(to bottom right, #e8c9a0, #c59962);
    -webkit-background-clip: text;
    color: transparent;
    vertical-align: middle;
    display: inline-block;
    margin-right: 15px;
  }
  em {
    font-size: 33px;
    color: #333333;
    line-height: 90px;
    vertical-align: middle;
  }
}
</style>
